"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __param = (this && this.__param) || function (paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
var _a, _b;
Object.defineProperty(exports, "__esModule", { value: true });
exports.GenericTableComponent = void 0;
/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable @typescript-eslint/naming-convention */
/* eslint-disable @typescript-eslint/no-loop-func */
/* eslint-disable no-continue */
/* eslint-disable global-require */
const core_1 = require("@angular/core");
const angular_1 = require("angular");
const filtering_1 = require("../shared/services/filtering");
const object_1 = __importDefault(require("../shared/services/object"));
let GenericTableComponent = class GenericTableComponent {
    constructor(filteringService, objectService, tableId) {
        this.filteringService = filteringService;
        this.objectService = objectService;
        this.tableId = tableId;
        this.filters = {};
        this.filterHash = '';
        this.filterCount = 0;
        this.tableData = [];
        this.filteredData = [];
        this.filterTags = [];
        this.showFilter = false;
        this.showMobileFilter = false;
        this.mainFilterMobile = false;
        this.filterMode = 'CLIENT';
        this.limit = 10;
        /**
         * Try to load the values of the filters from local storage.
         * To prevent updates in the filter object colliding with the saved copy,
         * the current filters a provided here.
         */
        this.loadFiltersFromStorage = () => {
            const filtersFromStorage = localStorage.getItem(`TableFilter_${this.tableId}`);
            if (!filtersFromStorage)
                return;
            const parsedFilters = JSON.parse(filtersFromStorage);
            if (!parsedFilters)
                return;
            for (const [filterKey, filterValue] of Object.entries(this.filters)) {
                if (parsedFilters[filterKey]) {
                    filterValue.value = parsedFilters[filterKey].value;
                }
            }
            this.filterTable();
        };
        this.saveFilterToLocalStorage = (filters) => {
            const filtersToSave = (0, angular_1.copy)(filters);
            for (const [filterKey, filterValue] of Object.entries(filtersToSave)) {
                if (!filterValue.value)
                    delete filtersToSave[filterKey];
            }
            localStorage.setItem(`TableFilter_${this.tableId}`, JSON.stringify(filtersToSave));
        };
        this.changeDataLimit = (newLimit) => {
            this.limit = newLimit;
        };
        this.sortDates = (date0, date1, _row0, _row1, sortDirection) => {
            let placeholderDate = new Date(0);
            if (sortDirection === 'desc') {
                placeholderDate = new Date(8640000000000000);
            }
            const dateA = date0 ? new Date(date0) : placeholderDate;
            const dateB = date1 ? new Date(date1) : placeholderDate;
            return dateB.getTime() - dateA.getTime();
        };
        this.sortPrices = (_value0, _value1, row0, row1, sortDirection) => {
            let placeholderPrice = -9999999;
            if (sortDirection === 'desc') {
                placeholderPrice = 999999;
            }
            let price0 = placeholderPrice;
            let price1 = placeholderPrice;
            if (row0.vehicleData.price.campaignPrice && row0.vehicleData.price.campaignPrice > 0) {
                price0 = row0.vehicleData.price.campaignPrice;
            }
            if (row0.vehicleData.price.onlinePrice && row0.vehicleData.price.onlinePrice > 0) {
                price0 = row0.vehicleData.price.onlinePrice;
            }
            if (row1.vehicleData.price.campaignPrice && row1.vehicleData.price.campaignPrice > 0) {
                price1 = row1.vehicleData.price.campaignPrice;
            }
            if (row1.vehicleData.price.onlinePrice && row1.vehicleData.price.onlinePrice > 0) {
                price1 = row1.vehicleData.price.onlinePrice;
            }
            return price1 - price0;
        };
        this.afterFiltering = () => {
            const query = {};
            Object.keys(this.filters).forEach((key) => {
                const { value, traversal } = this.filters[key];
                if (!value)
                    return;
                query[String(traversal)] = value.split(', ');
            });
            this.getTableData(query);
        };
    }
    /** Fix for ngx datatable not calculating width correctly on its own. */
    ngAfterViewChecked() {
        window.dispatchEvent(new Event('resize'));
    }
    generateFilterTags() {
        return __awaiter(this, void 0, void 0, function* () {
            this.filterTags = [];
            let id = 0;
            for (const [filterId, filter] of Object.entries(this.filters)) {
                if (!filter.value)
                    continue;
                filter.value.replace(/ /g, '').split(',').forEach((filterValue) => __awaiter(this, void 0, void 0, function* () {
                    const value = filterValue;
                    let description = filter.translations ? filter.translations[filterValue] : filterValue;
                    if (filterValue && filter.translationFunction) {
                        description = yield filter.translationFunction(filter.value);
                    }
                    this.filterTags.push({
                        filterId,
                        id,
                        value,
                        description,
                    });
                    id += 1;
                }));
            }
        });
    }
    filterTable() {
        if (this.filterMode === 'CLIENT') {
            this.filteredData = this.filteringService.filterDataset(this.tableData, this.filters);
            this.filterCount = Object
                .values(this.filters)
                .filter((v) => v.value !== undefined && v.value !== '').length;
            this.saveFilterToLocalStorage(this.filters);
        }
        this.generateFilterTags();
        this.afterFiltering();
    }
    removeFilter(tag) {
        var _a;
        if (!tag) {
            for (const [_, filter] of Object.entries(this.filters)) {
                delete filter.value;
            }
            this.filterTable();
            return;
        }
        const filter = this.filters[tag.filterId];
        if ((_a = filter.value) === null || _a === void 0 ? void 0 : _a.includes(',')) {
            filter.value = filter.value.replace(/ /g, '').split(',').filter((f) => f !== tag.value).join(', ');
        }
        else {
            delete filter.value;
        }
        this.filterTable();
    }
};
GenericTableComponent = __decorate([
    (0, core_1.Component)({
        selector: 'table-component',
        template: '<div>Generic Table Component</div>',
    }),
    __param(2, (0, core_1.Inject)(String)),
    __metadata("design:paramtypes", [typeof (_a = typeof filtering_1.FilteringService !== "undefined" && filtering_1.FilteringService) === "function" ? _a : Object, typeof (_b = typeof object_1.default !== "undefined" && object_1.default) === "function" ? _b : Object, String])
], GenericTableComponent);
exports.GenericTableComponent = GenericTableComponent;
